 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		71: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"2":"cycling-workouts~dashboard~planner~workout-builder~zwift-importer","3":"cycling-workouts~planner~workout-builder~zwift-importer","4":"vendors~activity~cycling-workouts~workout-builder~zwift-importer","5":"cycling-workouts~workout-builder~zwift-importer","6":"vendors~dashboard~planner~settings","7":"vendors~glossary~settings~tooltip-modal","10":"glossary~tooltip-modal","66":"activity","67":"admin","68":"ai-cycling-coach","69":"alternatives","70":"ambassadors","72":"changelog","73":"cycling-workouts","74":"dashboard","75":"glossary","76":"help","77":"highcharts","78":"legal","79":"mobile-app","80":"onboarding","81":"planner","82":"pricing","84":"settings","85":"tool-calories","86":"tool-critical-power","87":"tool-ftp","88":"tool-good-ftp","89":"tool-hr-zones","90":"tool-intensity-factor","91":"tool-lactate-threshold","92":"tool-power-to-weight","93":"tool-power-zones","94":"tool-race-time","95":"tool-running-pace","96":"tool-tss","97":"tool-variability-index","98":"tool-vo2-max","99":"tool-zone-2","100":"tools","101":"tooltip-modal","102":"training-plans","103":"unsubscribe","104":"upgrade","105":"vendors~highcharts","106":"vendors~mapbox","107":"workout-builder","108":"zwift-importer"}[chunkId]||chunkId) + "-" + {"0":"709cf0dc4a4e0f437611","1":"183e304209fac2b25453","2":"4d09811887b5516374bb","3":"8e583524cc9fbadc707f","4":"00931aaf150a66e73b67","5":"50f0eff328d326d50def","6":"1d685961f309c8dd0616","7":"97104d1ee7722708e7a0","8":"d4a7682f672ce44e368d","9":"264c5978986d50986ed8","10":"9a295eaf19949e2f91f2","11":"cb0f00649c96a306c830","12":"1788990acfed369da0ab","13":"b729d4c1f213d9feca6a","14":"521ab8dc846d60006d71","15":"3e0a02686310cc86e411","16":"6fca90fc65bc85243f37","17":"5d607cfc6c7b73ac7bc9","18":"0b7e4fcf90485ab33c05","19":"d0733592621bcf357675","20":"94bb9f214ae364a3f82e","21":"9467fe75ac40a1ea23f6","22":"52a807405234ebdbb1ce","23":"1bfe198926e1dd125a74","24":"354c60d5cf2d0d9d9193","25":"a686a1d6a1c71a3835e0","26":"455bc89b03d05d2397b2","27":"e246b4bb241459f1ca13","28":"8d5a5afb76d17fd8be2a","29":"2c4a0dca6431d74d6d26","30":"87c71f529de141330634","31":"d75fba6aedb7a96b6e0f","32":"9e454a64c8d4dc61c29a","33":"a8996d8cad8cbc9756e3","34":"f3058dcec1734a1270c8","35":"9470b4887ba60347c3b3","36":"b05821ac3b8222a5e890","37":"135432e9e69d100bbc58","38":"4e3f46fd4a3c60f169fe","39":"23623ef60bf10df96cb5","40":"192f36388fc4ae020615","41":"d9748ab515bfe88fee86","42":"ff45ede519e8d8284196","43":"3309c85beed6a8857a03","44":"4898255ba5011f2d94a2","45":"b2d8941b5006302ae6da","46":"7a1856f0ff9b3ff119d2","47":"1502f371a96ec7622ce3","48":"0c843b692cbd1a115f1f","49":"956c363c1b0b0f8dc2db","50":"7ed7ee40f72ee6e2bee4","51":"ea438649231baacb90ef","52":"3e8d21ebecb78f72be73","53":"4ee580bfdcca2cab7f58","54":"dae35d0211bd7d3f3495","55":"18a43f38c0db64326409","56":"9e816b921a0798abbe33","57":"b43867a6cd7aab808f64","58":"3f2cedaece86448b028b","59":"8159f315a34879d6d374","60":"e70a31a1655e6c955224","61":"37792b506250d3d3b1c4","62":"73593b4ac2215561eacb","63":"8cf5c8d773bdd80a1179","64":"f18003e1c08092e57014","65":"6be4f651d69b3a8e4de3","66":"861e6a0266299575f19e","67":"6edf37ad24ca023b70e5","68":"b0f8b5bed49201174eeb","69":"28650e8bb696f76b4802","70":"2d95139fb4dc49e7a497","72":"ea066ecec69d2843b6c4","73":"1cb819f89ce3fa03d4ed","74":"430e50f4eab0d03ffd38","75":"570c7a24887860d12165","76":"bb0e30d4e8fa777b829c","77":"949fc7e141384295d8a0","78":"cb680e95f9dbd5fcb12a","79":"d862616009c423559a95","80":"a30281e7f5a0da63d513","81":"00191dc16f49b297557d","82":"860b917b1863bd6340bb","84":"82b0e858fb8cf5c7ebbf","85":"c2a1a9f678cb2871adf5","86":"3a9e2e2f169846b776d3","87":"3bec98bb46d976e132ba","88":"81d0b5baceea1f8732b1","89":"2fbd09e22d330a928acc","90":"7620d63c3fbe87abd338","91":"bbfbdb8c632f7a7bedf6","92":"e1070f7f613a82a76679","93":"c2211b8ed522920d13ed","94":"0c205b552650bc9da650","95":"9147a6d690a8f3835219","96":"31c775f2a36af58b1471","97":"36dae77420b4ddaf103a","98":"9e6432215425261e0d58","99":"92c942d61a991e6453ad","100":"f759064e9c157a0b9f1e","101":"e22fe806f974aab75b58","102":"bdca3690046b15a6df98","103":"1ab4ae329208667358a8","104":"cf0e8c82614adeb616ce","105":"a10eb4d4efac326f1d82","106":"d2d18d0a668785e618fd","107":"37de33ede0154abaf106","108":"80fd1bf9a4f708792240","109":"178de3ce03aabf17a078"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"5":1,"8":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"66":1,"67":1,"68":1,"72":1,"73":1,"74":1,"76":1,"80":1,"81":1,"84":1,"85":1,"86":1,"87":1,"98":1,"102":1,"107":1,"108":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"2":"cycling-workouts~dashboard~planner~workout-builder~zwift-importer","3":"cycling-workouts~planner~workout-builder~zwift-importer","4":"vendors~activity~cycling-workouts~workout-builder~zwift-importer","5":"cycling-workouts~workout-builder~zwift-importer","6":"vendors~dashboard~planner~settings","7":"vendors~glossary~settings~tooltip-modal","10":"glossary~tooltip-modal","66":"activity","67":"admin","68":"ai-cycling-coach","69":"alternatives","70":"ambassadors","72":"changelog","73":"cycling-workouts","74":"dashboard","75":"glossary","76":"help","77":"highcharts","78":"legal","79":"mobile-app","80":"onboarding","81":"planner","82":"pricing","84":"settings","85":"tool-calories","86":"tool-critical-power","87":"tool-ftp","88":"tool-good-ftp","89":"tool-hr-zones","90":"tool-intensity-factor","91":"tool-lactate-threshold","92":"tool-power-to-weight","93":"tool-power-zones","94":"tool-race-time","95":"tool-running-pace","96":"tool-tss","97":"tool-variability-index","98":"tool-vo2-max","99":"tool-zone-2","100":"tools","101":"tooltip-modal","102":"training-plans","103":"unsubscribe","104":"upgrade","105":"vendors~highcharts","106":"vendors~mapbox","107":"workout-builder","108":"zwift-importer"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"d4aa2e17","4":"31d6cfe0","5":"1be60833","6":"31d6cfe0","7":"31d6cfe0","8":"a1a1ac68","9":"31d6cfe0","10":"31d6cfe0","11":"61c7e243","12":"61c7e243","13":"61c7e243","14":"61c7e243","15":"2f389482","16":"61c7e243","17":"61c7e243","18":"61c7e243","19":"a6b46e9d","20":"61c7e243","21":"61c7e243","22":"61c7e243","23":"5209a9a1","24":"71da6349","25":"f7381212","26":"124d1d99","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"e91d28c4","67":"5afe363e","68":"475867f1","69":"31d6cfe0","70":"31d6cfe0","72":"8ef9be1f","73":"12262c52","74":"4bd2bb02","75":"31d6cfe0","76":"1c58ab9a","77":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"9bd38e58","81":"e2b4df8b","82":"31d6cfe0","84":"017bca30","85":"40dbcddf","86":"7a930ee0","87":"467fc90f","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"31d6cfe0","92":"31d6cfe0","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"9a83ae2b","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"afe04cc0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"ac42cb4f","108":"fa328bb7","109":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d3s6jo6q0vpov5.cloudfront.net/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 264);
